module.exports = __webpack_public_path__ + "static/media/biponon-gray.e0c5a3e6.svg";